/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import withLoadingScreen from '../../HOCs/withLoadingScreen'
import withSnackbar from '../../HOCs/withSnackbar'
import useGetScheduleOrderNoti from '../../hooks/useGetScheduleOrderNoti'
import useToggleDialog from '../../hooks/useToggleDialog'
import { ContentWraper } from '../main/main.style'
import ScheduleOrderToast from './components/schedule-order-toast'
import { DEFAULT_SCHEDULE_FILTER, RECALL_INTERVAL, SCHEDULE_ORDER_URL } from './schedule-order.constants'

const ScheduleOrder = (props: any) => {
  //constant and state
  const history = useHistory()
  const [openConfirm, toggleConfirm, shouldRenderConfirm] = useToggleDialog()
  const [filter, setFilter] = useState({ ...DEFAULT_SCHEDULE_FILTER })

  const [data, loading, error, refetch] = useGetScheduleOrderNoti(filter)

  //! Function
  const gotoOrderList = () => {
    toggleConfirm()
    history.push(SCHEDULE_ORDER_URL)
  }

  //! Effect
  useEffect(() => {
    if (data?.isShow) {
      toggleConfirm()
    }
  }, [data])

  useEffect(() => {
    setInterval(() => {
      setFilter({
        reCall: filter.reCall + 1,
      })
    }, RECALL_INTERVAL)
  }, [])

  //render
  return shouldRenderConfirm ? (
    <ContentWraper>
      <ScheduleOrderToast
        visible={openConfirm}
        message={data.message}
        onClickMessage={gotoOrderList}
        onClose={toggleConfirm}
      />
    </ContentWraper>
  ) : null
}

export default withLoadingScreen(withSnackbar(ScheduleOrder))
